import { array, object, string } from "yup";

export const purchaserValidator = strings =>
    object({
        companyName: string("")
            .required(strings.register.validation.REQUIRED)
            .max(50, strings.register.validation.MAX_LENGTH.split("{length}").join(50)),
        address: string("")
            .required(strings.register.validation.REQUIRED)
            .max(256, strings.register.validation.MAX_LENGTH.split("{length}").join(256)),
        personInCharge: string("")
            .required(strings.register.validation.REQUIRED)
            .max(256, strings.register.validation.MAX_LENGTH.split("{length}").join(256)),
        phone: string("")
            .trim()
            .transform(value => {
                return value.split(" ").join("");
            })
            .matches(/^[0-9]+$/, strings.register.validation.PHONE)
            .required(strings.register.validation.REQUIRED)
            .max(50, strings.register.validation.MAX_LENGTH.split("{length}").join(50)),
        email: string("")
            .email(strings.register.validation.EMAIL)
            .required(strings.register.validation.REQUIRED)
            .max(50, strings.register.validation.MAX_LENGTH.split("{length}").join(50)),
        conferenceAttendType: string().required(strings.register.validation.REQUIRED),
        paymentType: string().required(strings.register.validation.REQUIRED)
    });

export const attendersValidator = strings =>
    object().shape({
        attenders: array()
            .of(
                object().shape({
                    attender: string()
                })
            )
            .required()
            .min(1)
    });

export const verificationValidator = strings =>
    object({
        captcha: string("").required(strings.register.validation.REQUIRED)
    });

export const loginValidator = strings =>
    object({
        code: string("")
            .required(strings.register.validation.REQUIRED)
            .trim()
            .transform(value => {
                if (value) return value.split(" ").join("").split("_").join("");
                else return "";
            })
    });
